import { call, put } from "redux-saga/effects";
import { api, notify, queryBuilder } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler } from "utils";
import { ListCompanyDocksActions } from "store/ducks/settings/company-docks";

import { CompanyDock } from "interfaces/company-dock";

export function* listCompanyDocksRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IListRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(api.get, `/docks?${queryString}`);
    const comboOptions = data.map((companyDock: CompanyDock) => ({
      value: companyDock.id,
      label: companyDock.name,
    }));

    yield put(ListCompanyDocksActions.success(comboOptions));
    if (onSuccess) onSuccess(comboOptions);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListCompanyDocksActions.failure(errorMessage));
  }
}
